<template>
  <div class="table-container">
    <offer-basket
      v-if="showBasket"
      v-bind:basketProp="basket"
      @hideBasket="hideBasket"
      @triggerReceiptModal="triggerReceiptModal"
    />
    <order-id-receipt
      v-if="showOrderIdReceipt"
      v-bind:orders="basketOrder"
      :showOrderHistoryLink="true"
      @hideOrderIdReceipt="hideReceiptModal()"
    />

    <div class="row py-3 mx-0">
      <div
        class="d-flex justify-content-start"
        :class="[isDeliveredIn ? 'col-xl-6 col-md-6 col-sm-6 col-xs-6' : 'col-xl-6 col-md-6 col-sm-6 col-xs-6']"
      >
        <label for="select-fuel-type" class="mr-2 mb-0 mt-2 text-nowrap">Filter by:</label>
        <el-select
          v-model="filtersSelected.fuelTypes"
          multiple
          collapse-tags
          value-key="_id"
          filterable
          placeholder="Select fuel"
        >
          <el-row class="row border-bottom pb-2 px-0" style="width: 103%" v-if="fuelTypeList.length > 0">
            <el-col class="pl-4 pt-2">
              <input
                class="ml-2"
                type="checkbox"
                v-model="allSelectedFuels"
                @change="onSelectAllDeselectAllFuels(allSelectedFuels, $event)"
              />
              <span class="pl-1">
                <label for="filter-checkbox-all">Select All</label>
              </span>
            </el-col>
          </el-row>
          <el-option v-for="fuelType in fuelTypeList" :key="fuelType._id" :label="fuelType.name" :value="fuelType._id">
          </el-option>
        </el-select>
        <el-select
          style="margin-left: 20px"
          v-if="isExrack || isContract"
          v-model="filtersSelected.terminals"
          multiple
          collapse-tags
          value-key="_id"
          filterable
          placeholder="Select terminal"
        >
          <el-row class="row border-bottom pb-2 px-0" style="width: 103%" v-if="terminalList.length > 0">
            <el-col class="pl-4 pt-2">
              <input
                class="ml-2"
                type="checkbox"
                v-model="allSelectedTerminals"
                @change="onSelectAllDeselectAllTerminals(allSelectedTerminals, $event)"
              />
              <span class="pl-1">
                <label for="filter-checkbox-all">Select All</label>
              </span>
            </el-col>
          </el-row>
          <el-option v-for="terminal in terminalList" :key="terminal._id" :label="terminal.name" :value="terminal._id">
          </el-option>
        </el-select>
      </div>

      <div
        class="col-xl-6 col-md-12 col-sm-12 col-12"
        :class="{ 'order-3 mt-2': $breakpoint.lgAndDown }"
        v-if="isDeliveredIn"
      >
        <span
          class="din-buttons d-flex align-items-start"
          :class="[$breakpoint.xsOnly ? 'justify-content-between' : 'justify-content-end']"
        >
          <button
            v-for="(day, dayIndex) in daysList"
            :key="dayIndex"
            class="btn day-selection"
            :class="[
              filtersSelected.days.includes(day) ? 'btn-neutral' : 'btn-outline-t_grey',
              { 'ml-2': dayIndex !== 0 },
            ]"
            @click="selectDay(day)"
          >
            {{ day | daydateformat }}
          </button>
        </span>
      </div>
    </div>
    <div :class="{ 'mx-3': $breakpoint.mdAndDown }">
      <table class="table responsive-table">
        <thead :class="{ 'd-none': !isDeliveredIn && offersList && offersList.length < 1 }">
          <tr>
            <!-- Delivery Location: only appear on Delivered-In -->
            <th v-if="isDeliveredIn">
              Delivery Location
              <i
                v-if="activeSortColumn == 'delivery_location' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'delivery_location' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('delivery_location', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'delivery_location' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('delivery_location', 'asc')"
              ></i>
            </th>
            <th v-if="!isDeliveredIn">
              Contract Ref.
              <i
                v-if="activeSortColumn == 'contract_ref' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'contract_ref' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('contract_ref', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'contract_ref' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('contract_ref', 'asc')"
              ></i>
            </th>
            <th>
              Fuel
              <i
                v-if="activeSortColumn == 'fuel' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'fuel' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('fuel', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'fuel' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('fuel', 'asc')"
              ></i>
            </th>
            <th>
              Seller
              <i
                v-if="activeSortColumn == 'seller' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'seller' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('seller', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'seller' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('seller', 'asc')"
              ></i>
            </th>
            <!-- Terminal: only appear on Ex-Rack and Contract -->
            <th v-if="isExrack || isContract">
              Terminal
              <i
                v-if="activeSortColumn == 'terminal' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'terminal' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('terminal', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'terminal' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('terminal', 'asc')"
              ></i>
            </th>
            <th>
              <span v-if="isDeliveredIn">Vol/L</span>
              <span v-else>Vol Min-Max/L</span>
              <i
                v-if="activeSortColumn == 'volume_max' && activeSortDirection == 'asc'"
                class="fas fa-sort-numeric-down sort-icon"
                :class="{ selected: activeSortColumn == 'volume_max' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('volume_max', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'volume_max' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-numeric-up']
                    : 'fa-sort-numeric-down'
                "
                size="lg"
                @click="sortColumn('volume_max', 'asc')"
              ></i>
            </th>
            <th v-if="isContract">
              Total Vol/L
              <i
                v-if="activeSortColumn == 'volume_total' && activeSortDirection == 'asc'"
                class="fas fa-sort-numeric-down sort-icon"
                :class="{ selected: activeSortColumn == 'volume_total' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('volume_total', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'volume_total' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-numeric-up']
                    : 'fa-sort-numeric-down'
                "
                size="lg"
                @click="sortColumn('volume_total', 'asc')"
              ></i>
            </th>
            <th>
              Measurement
              <i
                v-if="activeSortColumn == 'measurement' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'measurement' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('measurement', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'measurement' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('measurement', 'asc')"
              ></i>
            </th>
            <th v-if="!isBunkering">
              <span v-if="isDeliveredIn">Delivery Date</span>
              <span v-else>Lifting Period</span>
              <i
                v-if="activeSortColumn == 'collection_days' && activeSortDirection == 'asc'"
                class="fas fa-sort-numeric-down sort-icon"
                :class="{ selected: activeSortColumn == 'collection_days' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('collection_days', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'collection_days' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-numeric-up']
                    : 'fa-sort-numeric-down'
                "
                size="lg"
                @click="sortColumn('collection_days', 'asc')"
              ></i>
            </th>
            <th>
              Payment Terms
              <i
                v-if="activeSortColumn == 'credit_days' && activeSortDirection == 'asc'"
                class="fas fa-sort-numeric-down sort-icon"
                :class="{ selected: activeSortColumn == 'credit_days' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('credit_days', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'credit_days' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-numeric-up']
                    : 'fa-sort-numeric-down'
                "
                size="lg"
                @click="sortColumn('credit_days', 'asc')"
              ></i>
            </th>
            <th v-if="!isContract">
              Offer Type
              <i
                v-if="activeSortColumn == 'offer_type' && activeSortDirection == 'asc'"
                class="fas fa-sort-alpha-down sort-icon"
                :class="{ selected: activeSortColumn == 'offer_type' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('offer_type', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'offer_type' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-alpha-up']
                    : 'fa-sort-alpha-down'
                "
                size="lg"
                @click="sortColumn('offer_type', 'asc')"
              ></i>
            </th>
            <th>
              Price (ppl)
              <i
                v-if="activeSortColumn == 'price' && activeSortDirection == 'asc'"
                class="fas fa-sort-numeric-down sort-icon"
                :class="{ selected: activeSortColumn == 'price' && activeSortDirection == 'asc' }"
                size="lg"
                @click="sortColumn('price', 'desc')"
              ></i>
              <i
                v-else
                class="fas sort-icon"
                :class="
                  activeSortColumn == 'price' && activeSortDirection == 'desc'
                    ? ['selected', 'fa-sort-numeric-up']
                    : 'fa-sort-numeric-down'
                "
                size="lg"
                @click="sortColumn('price', 'asc')"
              ></i>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <!-- If no offers is found -->
          <tr
            class="bg-transparent border-0 shadow-none w-100"
            v-if="!isDeliveredIn && offersList && offersList.length < 1"
          >
            <td class="px-0" :class="{ 'no-results d-flex': $breakpoint.mdAndDown }">
              <div class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
                <i class="fas fa-info-circle mr-2"></i>No offers found
              </div>
            </td>
          </tr>
          <tr
            v-for="(haulage, key) in haulageList"
            :key="key"
            v-else-if="isDeliveredIn"
            :class="{ 'py-2': $breakpoint.mdAndDown }"
          >
            <td label="Delivery Location" v-if="haulage.valid">
              <!-- <span v-if="key == 0 || haulageList[key - 1].location_id !== haulage.location_id">{{haulage.location.name}}</span> -->
              <span>{{ haulage.location.name }}</span>
            </td>
            <td label="Fuel" v-if="haulage.valid">
              <span>{{ haulage.fuel.name }}</span>
            </td>
            <td label="Seller" v-if="haulage.valid">
              <span>{{ haulage.seller.name }}</span>
            </td>
            <td v-if="haulage.valid">
              <span v-if="haulage.fuel_id == productConfig.KeroseneId">37,500</span>
              <span v-else>36,000</span>
            </td>
            <td label="Measurement" v-if="haulage.valid">
              <span>{{ haulage.fuel_measurement_id | fuelmeasurementtype }}</span>
            </td>
            <td label="Delivery Date" v-if="haulage.valid">
              <span>{{ haulage.deliveryDate | daydateformat }}</span>
            </td>
            <td label="Payment Terms" v-if="haulage.valid">
              <span>{{ haulage.credit.days | creditdaysformat }}</span>
            </td>
            <td label="Offer Type" v-if="haulage.valid">
              <span>{{ haulage.isContract | contracttype }}</span>
            </td>
            <td label="Price (ppl)" v-if="haulage.valid">
              <span>{{ haulage.dayDeliveryPpl | priceformat }}&nbsp;</span>
              <i
                v-if="haulage.type_id === 'TRACKING'"
                class="fas fa-sm fa-rss tracking-active-icon-color mb-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="This Offer Price updates every 30 seconds"
              ></i>
            </td>
            <td class="text-right" v-if="haulage.valid">
              <button
                class="btn btn-confirm w-120px"
                :disabled="getIsPlatformClosed"
                @click="openBasket(haulage, $event)"
              >
                Buy
              </button>
            </td>
            <th class="no-results" :class="{ 'w-50': $breakpoint.mdAndDown }" v-if="!haulage.valid">
              {{ haulage.name }}
            </th>
            <td
              class="no-results text-center"
              :class="{ 'w-50': $breakpoint.mdAndDown }"
              v-if="!haulage.valid"
              colspan="8"
            >
              No offers available at this time
            </td>
          </tr>
          <!-- Show table without filters applied -->
          <tr v-else v-for="(offer, key) in offersList" :key="key" :class="{ 'py-2': $breakpoint.mdAndDown }">
            <!-- Display seller details if data is available -->
            <td label="Contract Reference" :style="$breakpoint.mdAndDown ? 'width:100%;' : 'width:13%;'">
              <span v-if="offer.contract">
                <button
                  v-if="offer.type_id === 'TRACKING'"
                  class="btn p-0 text-t_blue text-left"
                  :class="$breakpoint.mdAndDown ? 'text-right' : 'text-left'"
                  :style="$breakpoint.smAndDown ? 'font-size: 12px;' : 'font-size: 13px;'"
                  @click="openContractReportModal(offer)"
                >
                  {{ offer.contract.reference }}
                </button>
                <span v-else>{{ offer.contract.reference }}</span>
              </span>
            </td>
            <td label="Fuel" v-if="offer.fuel">
              <span>{{ offer.fuel.name }}</span>
            </td>
            <td label="Seller" v-if="offer.seller">
              <span>{{ offer.seller.name }}</span>
            </td>
            <td label="Delivery Location" v-else><span>N/A</span></td>
            <!-- Terminal: only display under Ex-Rack and Contract tabs -->
            <td label="Terminal" v-if="isExrack || isContract">
              <span v-if="offer.storage_type_id == 'BUNKERING'">{{
                networks.find((n) => n._id === offer.networkId).name
              }}</span>
              <span v-else-if="offer.terminal">{{ offer.terminal.name }}</span>
              <span v-else>N/A</span>
            </td>
            <td :label="isDeliveredIn ? 'Vol/L' : 'Vol Min-Max/L'">
              <span>{{ offerVolumeDisplay(offer) }}</span>
            </td>
            <!-- Volume total: only display under Contract tab -->
            <td label="Total Vol/L" v-if="isContract">
              <span>{{ offer.contract.totalQuantity | volumeformat }}</span>
            </td>
            <td label="Measurement">
              <span>{{ offer.fuel_measurement_id | fuelmeasurementtype }}</span>
            </td>
            <!-- Lifting Period: hide under Bunkering tab -->
            <td label="Lifting Period" v-if="!isBunkering">
              <span v-if="offer.storage_type_id == 'BUNKERING'">N/A</span>
              <span v-else>{{ offer | liftingperiodformat }}</span>
            </td>
            <!-- Display credit details if data is available -->
            <td label="Payment Terms" v-if="offer.credit">
              <span>{{ offer.credit.days | creditdaysformat }}</span>
            </td>
            <td v-else><span>N/A</span></td>
            <td label="Offer Type" v-if="!isContract">
              <span>{{ offer.isContract | contracttype }}</span>
            </td>
            <td label="Price (ppl)">
              <span v-if="offer.type_id === 'SETTLEMENT'">Pending Settlement</span>
              <span v-else>{{ offer.price | priceformat }}&nbsp;</span>
              <i
                v-if="offer.type_id === 'TRACKING'"
                class="fas fa-sm fa-rss tracking-active-icon-color mb-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="This Offer Price updates every 30 seconds"
              ></i>
            </td>
            <td class="text-right">
              <button
                class="btn btn-confirm w-120px"
                :disabled="getIsPlatformClosed"
                @click="openBasket(offer, $event)"
              >
                Buy
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <contract-report
      v-if="showContractReport"
      v-bind:selectedContract="selectedContract"
      v-on:hideContractReport="hideContractReport"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import breakpoint from "@/mixins/index";
import CreateBasketMixin from "@/mixins/CreateBasketMixin";

import OfferBasket from "@/modals/OfferBasket.vue";
import OrderIdReceipt from "@/modals/OrderIdReceipt.vue";
import ContractReport from "@/modals/ContractReport.vue";

import { getCurrentMonthDataFromContract } from "../../util/util.js";
import { hasContractRemainingQuantity, populateContractDetails } from "@/util/contracts.js";
import { organiseOrders } from "../../util/orderBuilder";

const moment = require("moment");
const momentBusiness = require("moment-business-days");

export default {
  data() {
    return {
      filtersSelected: {
        fuelTypes: [],
        terminals: [],
        days: [],
      },
      activeSortColumn: "",
      activeSortDirection: "",
      locationsWithoutOffers: [],
      showBasket: false,
      showOrderIdReceipt: false,
      basketOrder: {},
      showContractReport: false,
      selectedContract: {},
      allSelectedTerminals: true,
      allSelectedFuels: true,
    };
  },
  components: {
    OfferBasket,
    OrderIdReceipt,
    ContractReport,
  },
  mixins: [breakpoint, CreateBasketMixin],
  created: function () {
    if (this.getSuppliersChanges.length === 0) {
      this.getRelationships();
    }
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  mounted() {
    this.assignCompatibleFilters();
  },
  computed: {
    ...mapGetters("buyerOpen", ["getIsPlatformClosed"]),
    ...mapGetters("allPrices", ["activeTabIndex", "isDeliveredIn", "isExrack", "isBunkering", "isContract"]),
    ...mapGetters("accounts", ["getSuppliersChanges"]),
    ...mapGetters("login", ["getAccountId"]),
    ...mapGetters("offers", ["liveOffers", "haulageAvailableList", "deliveryLocations", "fuelsIds"]),
    ...mapGetters("orders", ["marketWindowId"]),
    ...mapGetters("fuelsType", ["getFuelsType"]),
    ...mapGetters("metadata", ["productConfig", "networkConfig", "networks"]),
    ...mapState("itemRemoval", ["showItemRemovalConfirmation"]),
    openModals: function () {
      if (this.showItemRemovalConfirmation) {
        let element = this.$root.$refs.confirmationRemoveItem.$el;
        $(element).modal({ backdrop: "static", keyboard: false });
      }
      return null;
    },
    fuelTypeListExrack: {
      get: function () {
        if (this.getFuelsType) {
          return this.getFuelsType.filter((fuel) => fuel.type === "SPOT");
        }
        return []
      },
    },
    fuelTypeList: {
      get: function () {
        if (this.isBunkering) {
          return this.networks;
        } else if (this.isContract && this.fuelTypeListExrack && this.networks) {
          return [...this.fuelTypeListExrack, ...this.networks];
        } else {
          return this.fuelTypeListExrack;
        }
      },
    },
    terminalList: {
      get: function () {
        const allTerminals = this.liveOffers.filter((offer) => offer.terminal).map(({ terminal }) => terminal);
        return allTerminals.reduce((terminals, terminal) => {
          return terminals.map(({ _id }) => _id).includes(terminal._id) ? terminals : [...terminals, terminal];
        }, []);
      },
    },
    offersList: {
      get: function () {
        if (this.filtersSelected.fuelTypes.length && this.liveOffers) {
          let offers = this.liveOffers.filter((offer) => {
            switch (this.activeTabIndex) {
              case 0: // Ex-Rack offers
                if (offer.storage_type_id == "SPOT" && !offer.offerHidden) {
                  if (offer.isContract) {
                    if (hasContractRemainingQuantity(offer.contract.frequency_quantity, offer.minimumOrderQuantity)) {
                      return offer;
                    }
                  } else {
                    return offer;
                  }
                }
                break;
              case 1: // Bunkering offers
                if (offer.storage_type_id == "BUNKERING" && !offer.offerHidden) {
                  if (offer.isContract) {
                    if (hasContractRemainingQuantity(offer.contract.frequency_quantity, offer.minimumOrderQuantity)) {
                      return offer;
                    }
                  } else {
                    return offer;
                  }
                }
                break;
              case 2: // Contracts
                let currentMonth;
                if (offer.contract && offer.contract.frequency_quantity) {
                  currentMonth = getCurrentMonthDataFromContract(offer.contract.frequency_quantity);
                }
                return (
                  offer.isContract &&
                  !offer.offerHidden &&
                  (currentMonth ? currentMonth.maximumAvailable >= offer.minimumOrderQuantity : true)
                );
              default:
                return;
            }
          });

          /* Filter based on fuel type selected */
          offers = offers.filter((offer) => {
            if (
              offer.storage_type_id == "SPOT" &&
              (offer.fuel_id == this.productConfig.DieselId || offer.fuel_id == this.productConfig.BlendedDieselBioId)
            ) {
              // Diesel
              return this.filtersSelected.fuelTypes.includes(this.productConfig.DieselId);
            }
            if (
              offer.storage_type_id == "SPOT" &&
              (offer.fuel_id == this.productConfig.GasoilId || offer.fuel_id == this.productConfig.BlendedGasoilId)
            ) {
              // Gasoil
              return this.filtersSelected.fuelTypes.includes(this.productConfig.GasoilId);
            }
            if (offer.storage_type_id == "BUNKERING" && offer.networkId == this.networkConfig.KeyFuelsId) {
              // Keyfuels
              return this.filtersSelected.fuelTypes.includes(this.networkConfig.KeyFuelsId);
            }
            if (offer.storage_type_id == "BUNKERING" && offer.networkId == this.networkConfig.UkFuelsId) {
              // UK Fuels
              return this.filtersSelected.fuelTypes.includes(this.networkConfig.UkFuelsId);
            }
            {
              return this.filtersSelected.fuelTypes.includes(offer.fuel_id);
            }
          });

          // Filter based on terminal selection
          offers = offers.filter(({ terminal }) => !terminal || this.filtersSelected.terminals.includes(terminal._id));

          // Attach seller details to each offer
          offers.forEach((offer) => {
            offer.seller_details = this.getSuppliersChanges.find((supplier) => supplier.id == offer.account_id);
          });

          /* If any column has been selected for sorting, then re-apply sorting */
          if (this.activeSortColumn && this.activeSortDirection) {
            return this.sortColumn(this.activeSortColumn, this.activeSortDirection, offers);
          }

          return offers;
        }
        return [];
      },
    },
    haulageList: {
      get: function () {
        if (this.filtersSelected.fuelTypes.length && this.haulageAvailableList) {
          let list = [];
          let daysSelected = [];

          /* Re-format days selected here to safeguard against changes */
          if (this.filtersSelected.days) {
            this.filtersSelected.days.forEach((day) => {
              daysSelected.push(moment(day).format("DD-MM-YYYY"));
            });
          }

          /* Filter based on fuel type */
          list = this.haulageAvailableList.filter((haulage) => {
            if ([this.productConfig.DieselId, this.productConfig.BlendedDieselBioId].includes(haulage.fuel.id)) {
              return this.filtersSelected.fuelTypes.includes(this.productConfig.DieselId);
            }
            if ([this.productConfig.GasoilId, this.productConfig.BlendedGasoilId].includes(haulage.fuel.id)) {
              return this.filtersSelected.fuelTypes.includes(this.productConfig.GasoilId);
            }
            return this.filtersSelected.fuelTypes.includes(haulage.fuel.id);
          });

          // Filter based on days selected
          list = list.filter((haulage) => daysSelected.includes(moment(haulage.deliveryDate).format("DD-MM-YYYY")));

          /* Attach the relevant offer and seller details */
          list.forEach((haulage) => {
            haulage.seller_details = this.getSuppliersChanges.find((supplier) => supplier.id == haulage.account_id);
            haulage.valid = true;
          });

          /* Add locations without offers to the list */
          let offerLocationsIDs = [...new Set(list.map((a) => a.location_id))];
          this.locationsWithoutOffers = this.deliveryLocations.filter((location) => {
            if (!offerLocationsIDs.includes(location._id)) {
              return location;
            }
          });
          this.locationsWithoutOffers.forEach(function (element) {
            list.push(element);
          });

          /* If any column has been selected for sorting, then re-apply sorting */
          if (this.activeSortColumn && this.activeSortDirection) {
            return this.sortColumn(this.activeSortColumn, this.activeSortDirection, list);
          }

          return list;
        }
        return [];
      },
    },
    daysList: {
      get: function () {
        const today = moment().format("DD-MM-YYYY");
        let days = [];

        days.push(momentBusiness(today, "DD-MM-YYYY").businessAdd(1)._d);
        days.push(momentBusiness(today, "DD-MM-YYYY").businessAdd(2)._d);
        days.push(momentBusiness(today, "DD-MM-YYYY").businessAdd(3)._d);
        days.push(momentBusiness(today, "DD-MM-YYYY").businessAdd(4)._d);
        days.push(momentBusiness(today, "DD-MM-YYYY").businessAdd(5)._d);

        return days;
      },
    },
  },
  watch: {
    activeTabIndex: function () {
      this.assignCompatibleFilters()
    },
    openModals() {},
    'filtersSelected.fuelTypes'() {
      if (this.filtersSelected.fuelTypes.length !== this.fuelTypeList.length) {
        this.allSelectedFuels = false
      }
      if (this.filtersSelected.fuelTypes.length === this.fuelTypeList.length) {
        this.allSelectedFuels = true
      }
    },
    'filtersSelected.terminals'() {
      if (this.filtersSelected.terminals.length !== this.terminalList.length) {
        this.allSelectedTerminals = false
      }
      if (this.filtersSelected.terminals.length === this.terminalList.length) {
        this.allSelectedTerminals = true
      }
    }
  },
  methods: {
    ...mapActions("accounts", ["getRelationships"]),
    openContractReportModal: async function (offer) {
      offer.sellerName = offer.seller_details.name;
      offer.fuelName = offer.fuel.name;
      this.selectedContract = populateContractDetails(offer, "OFFER");
      this.showContractReport = true;
    },
    assignCompatibleFilters() {
      if (this.activeTabIndex > -1 && this.getFuelsType.length > 0 && this.networks.length > 0 && this.daysList) {
        if (this.isBunkering) {
          // bunkering
          this.filtersSelected.fuelTypes = this.networks.map(({ _id }) => _id);
        } else {
          this.assignPreselectedFuelTypes();
        }
        if (this.isExrack || this.isContract) {
          this.assignPreselectedTerminals();
        }
        //Ex-Rack, Contracts, DIN
        if (this.isDeliveredIn) {
          //Only DIN
          this.filtersSelected.days = Object.assign([], this.daysList);
          return null;
        }
      }
    },
    assignPreselectedFuelTypes () {
      if (this.fuelTypeList && this.fuelTypeList.length > 0) {
        this.filtersSelected.fuelTypes = this.fuelTypeList.map(item => item._id);
      } else {
        this.filtersSelected.fuelTypes = [];
      }
    },
    assignPreselectedTerminals () {
      if (this.terminalList && this.terminalList.length > 0) {
        this.filtersSelected.terminals = this.terminalList.map(item => item._id);
      } else {
        this.filtersSelected.terminals = [];
      }
    },
    onSelectAllDeselectAllFuels(val) {
      if (val) {
        if (this.fuelTypeList && this.fuelTypeList.length > 0) {
          this.filtersSelected.fuelTypes = this.fuelTypeList.map(item => item._id);
        } else {
          this.filtersSelected.fuelTypes = [];
        }
      } else {
        this.filtersSelected.fuelTypes = [];
      }
    },
    onSelectAllDeselectAllTerminals(val) {
      if (val) {
        if (this.terminalList && this.terminalList.length > 0) {
          this.filtersSelected.terminals = this.terminalList.map(item => item._id);
        } else {
          this.filtersSelected.terminals = [];
        }
      } else {
        this.filtersSelected.terminals = [];
      }
    },
    hideContractReport() {
      this.showContractReport = false;
    },
    selectDay: function (daySelected) {
      if (this.filtersSelected.days.includes(daySelected)) {
        const dayMatchIndex = this.filtersSelected.days.findIndex((day) => day == daySelected);
        this.filtersSelected.days.splice(dayMatchIndex, 1);
      } else {
        this.filtersSelected.days.push(daySelected);
      }
    },
    hideBasket() {
      this.showBasket = false;
    },
    triggerReceiptModal(order) {
      this.basketOrder = organiseOrders(
        [order],
        this.$store.getters["login/getAccountType"],
        this.$store.getters["metadata/networks"]
      );
      this.showOrderIdReceipt = true;
    },
    hideReceiptModal() {
      this.showOrderIdReceipt = false;
    },
    sortColumn: function (columnIndex, direction, list) {
      let listToSort = list ? list : this.isDeliveredIn ? this.haulageList : this.offersList;
      let stringA = "";
      let stringB = "";

      this.activeSortDirection = direction;
      this.activeSortColumn = columnIndex;

      switch (columnIndex) {
        case "delivery_location": // Sort by delivery location
          return listToSort.sort((a, b) => {
            stringA = a.location ? a.location.name : a.name;
            stringB = b.location ? b.location.name : b.name;

            if (direction == "asc") {
              return stringA.localeCompare(stringB, "en");
            } else {
              return stringB.localeCompare(stringA, "en");
            }
          });
        case "terminal": // Sort by terminal
          return listToSort.sort((a, b) => {
            if (a.terminal && b.terminal) {
              stringA = a.terminal.name;
              stringB = b.terminal.name;
            } else if (a.terminal) {
              stringA = a.terminal.name;
              stringB = "N/A";
            } else if (b.terminal) {
              stringA = "N/A";
              stringB = b.terminal.name;
            } else {
              stringA = "N/A";
              stringB = "N/A";
            }

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        case "seller": // Sort by seller
          return listToSort.sort((a, b) => {
            stringA = a.seller_details ? a.seller_details.name : "zzz";
            stringB = a.seller_details ? b.seller_details.name : "zzz";

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        case "fuel": // Sort by fuel
          return listToSort.sort((a, b) => {
            stringA = a.fuel ? a.fuel.name : "zzz";
            stringB = b.fuel ? b.fuel.name : "zzz";

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        case "volume_min": // Sort by minimum volume
          return listToSort.sort((a, b) => {
            if (direction == "asc") {
              return a.minimumOrderQuantity - b.minimumOrderQuantity;
            } else {
              return b.minimumOrderQuantity - a.minimumOrderQuantity;
            }
          });
        case "volume_max": // Sort by maximum volume
          return listToSort.sort((a, b) => {
            if (direction == "asc") {
              return a.maximumAvailable - b.maximumAvailable;
            } else {
              return b.maximumAvailable - a.maximumAvailable;
            }
          });
        case "volume_total": // Sort by total volume
          return listToSort.sort((a, b) => {
            stringA = a.maximumAvailable - a.contract.orderedQuantity;
            stringB = b.maximumAvailable - b.contract.orderedQuantity;

            if (direction == "asc") {
              return stringA - stringB;
            } else {
              return stringB - stringA;
            }
          });
        case "measurement": // Sort by fuel measurement type
          return listToSort.sort((a, b) => {
            stringA = this.$root.$options.filters.fuelmeasurementtype(a.fuel_measurement_id);
            stringB = this.$root.$options.filters.fuelmeasurementtype(b.fuel_measurement_id);

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        case "collection_days": // Sort by Lifting Period
          return listToSort.sort((a, b) => {
            stringA = this.isDeliveredIn
              ? a.deliveryDate
                ? new Date(a.deliveryDate)
                : Number.MAX_SAFE_INTEGER
              : a.collectionTime;
            stringB = this.isDeliveredIn
              ? b.deliveryDate
                ? new Date(b.deliveryDate)
                : Number.MAX_SAFE_INTEGER
              : b.collectionTime;

            if (direction == "asc") {
              return stringA - stringB;
            } else {
              return stringB - stringA;
            }
          });
        case "credit_days": // Sort by credit days
          return listToSort.sort((a, b) => {
            stringA = a.credit ? a.credit.days : Number.MAX_SAFE_INTEGER;
            stringB = b.credit ? b.credit.days : Number.MAX_SAFE_INTEGER;

            if (direction == "asc") {
              return stringA - stringB;
            } else {
              return stringB - stringA;
            }
          });
        case "offer_type": // Sort by offer type
          return listToSort.sort((a, b) => {
            stringA = this.$root.$options.filters.contracttype(a.isContract);
            stringB = this.$root.$options.filters.contracttype(b.isContract);

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        case "price": // Sort by price
          return listToSort.sort((a, b) => {
            stringA = this.isDeliveredIn ? a.dayDeliveryPpl : a.price;
            stringB = this.isDeliveredIn ? b.dayDeliveryPpl : b.price;

            if (direction == "asc") {
              return stringA - stringB;
            } else {
              return stringB - stringA;
            }
          });
        case "contract_ref": // Sort by contract reference
          return listToSort.sort((a, b) => {
            stringA = a.contract ? a.contract.reference : "~";
            stringB = b.contract ? b.contract.reference : "~";

            if (direction == "asc") {
              if (stringA < stringB) {
                return -1;
              }
              if (stringA > stringB) {
                return 1;
              }
              return 0;
            } else {
              if (stringA < stringB) {
                return 1;
              }
              if (stringA > stringB) {
                return -1;
              }
              return 0;
            }
          });
        default:
          return listToSort;
      }
    },
    offerVolumeDisplay(offer) {
      const { volumeformat, currentMonthMaximumAvailable } = this.$options.filters;
      let maximumAvailable;

      if (offer.contract && offer.contract.frequency_quantity && offer.contract.frequency_quantity.length > 0) {
        maximumAvailable = currentMonthMaximumAvailable(offer.contract.frequency_quantity);
      } else {
        maximumAvailable = volumeformat(offer.maximumAvailable);
      }

      return this.isDeliveredIn
        ? `${volumeformat(maximumAvailable)}`
        : `${volumeformat(offer.minimumOrderQuantity)} - ${maximumAvailable}`;
    },
  },
};
</script>
